module.exports = __webpack_public_path__ + "static/media/iconMenu.fed95e91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconMenu.svg
// module id = 1010
// module chunks = 0